export default "__VITE_ASSET__DKMGUA0O__"